import InfoCard from "./InfoCard"
import './Services.css'
import data from './ServciesData'

export default function Servcies(){
    const serviceInfoCards = data.map((service) => {
        return(
            <InfoCard
                key={service.id}
                {...service} />
        )
    })

    return (
        <section id="services">
            <div id="services-container">
                <div className="spacer"></div>
                {serviceInfoCards}
                <div className="spacer"></div>
            </div>
        </section>
    )
}